import dynamic from 'next/dynamic';

export const ChangeEmailModalDynamic = dynamic(
  () =>
    import('./ChangeEmailModal.client').then((mod) => ({
      default: mod.ChangeEmailModal,
    })),
  { ssr: false },
);
